import store from '@/store'

const isAuthenticatedGuardAdmin = async (to, from, next) => {

    const {ok, message} = await store.dispatch('admin/checkAuthentication')
    if(ok) next()
    else next({name: 'auth-admin'})
}

export default isAuthenticatedGuardAdmin